module.exports = __webpack_public_path__ + "assets/img/empty-state-groups.1dfe7fd2.svg";